"use strict";
import { createSlice } from "@reduxjs/toolkit";
import { getUniquePositionId } from "features/visibility/utils";
export const initialVisibilityState = {
  positions: {},
  tokens: {},
  nfts: {}
};
export const slice = createSlice({
  name: "visibility",
  initialState: initialVisibilityState,
  reducers: {
    togglePositionVisibility: (state, {
      payload: { poolId, tokenId, chainId }
    }) => {
      const positionId = getUniquePositionId(poolId, tokenId, chainId);
      const isVisible = state.positions[positionId]?.isVisible ?? true;
      state.positions[positionId] = { isVisible: !isVisible };
    },
    setTokenVisibility: (state, { payload: { currencyId, isVisible } }) => {
      state.tokens[currencyId] = { ...state.tokens[currencyId], isVisible };
    },
    setNftVisibility: (state, { payload: { nftKey, isVisible } }) => {
      state.nfts ??= {};
      state.nfts[nftKey] = { isVisible };
    }
  }
});
export const { togglePositionVisibility, setTokenVisibility, setNftVisibility } = slice.actions;
export const { reducer: visibilityReducer } = slice;
